import fetchData from 'api/fetch';
import baseUrl from 'constants/baseUrl';

import type { getDataType } from 'utils/types';

const getData = async ({ tag, itemLimit }: getDataType) => {
  try {
    const data = await fetchData(`${baseUrl}/search?q=${tag}?&limit=${itemLimit}&offset=0`);

    return data.response;
  } catch (error) {
    console.trace('error', error.message);
    return null;
  }
};

export default getData;
